export const setElementDisabled = (
  element: HTMLElement | null,
  disabled: boolean,
) => {
  if (!element) {
    return;
  }

  if (disabled) {
    element.setAttribute('disabled', 'true');
    element.setAttribute('tabindex', '-1');
    element.style.pointerEvents = 'none';
  } else {
    element.removeAttribute('disabled');
    element.removeAttribute('tabindex');
    element.style.pointerEvents = 'all';
  }
};
